// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__SiUph","myModalContent":"MyModal_myModalContent__q5+jG","active":"MyModal_active__GYVgC"};